import { getToken } from "../../../../shared/data/storage/authStorage";
import { API_BASE_URL } from "../../../../config/api";

class APIError extends Error {
  public status: number;
  public data: any;

  constructor(message: string, status: number, data: any = null) {
    super(message);
    this.name = "APIError";
    this.status = status;
    this.data = data;
  }
}

export interface ChangePasswordRequestDTO {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

export interface ChangePasswordResponseDTO {
  success: boolean;
  message: string;
}

// Change password
export const changePasswordApi = async (
  data: ChangePasswordRequestDTO
): Promise<ChangePasswordResponseDTO> => {
  const token = getToken();
  if (!token) {
    throw new APIError("Not authenticated", 401);
  }

  const url = `${API_BASE_URL}/api/password/change`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new APIError(
        errorData.message || `HTTP error! status: ${response.status}`,
        response.status,
        errorData
      );
    }

    return await response.json();
  } catch (error) {
    if (error instanceof APIError) {
      throw error;
    }
    throw new APIError(
      `Network error: ${error instanceof Error ? error.message : "Unknown error"}`,
      500
    );
  }
};

